import * as React from 'react';

const InternalServerErrorIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="480"
      height="280"
      viewBox="0 0 480 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="internal-server-error-illustration"
    >
      <ellipse cx="321" cy="224" rx="97" ry="13" fill="#E6E8E9" />
      <path
        d="M289.046 180.699L290.954 181.3C284.309 202.381 224.576 221.243 192.751 213.072L193.249 211.135C224.167 219.073 282.785 200.563 289.046 180.699Z"
        fill="#040B2B"
      />
      <path
        d="M301.917 190.053L299.233 207.535C299.233 207.535 286.02 214.696 295.31 214.906C304.6 215.117 348.366 214.906 348.366 214.906C348.366 214.906 356.83 214.906 343.412 207.324L340.728 189L301.917 190.053Z"
        fill="#040B2B"
      />
      <path
        d="M293.439 214.959C295.549 213.101 299.23 211.164 299.23 211.164L301.914 194.197L340.727 194.233L343.411 210.959C346.541 212.675 348.479 213.991 349.613 215C351.337 214.611 353.22 213.164 343.411 207.784L340.727 190L301.914 191.022L299.23 207.989C299.23 207.989 288.128 213.83 293.439 214.959Z"
        fill="#03071C"
      />
      <path
        d="M233 88.0457C233 78.0793 241.079 70 251.046 70H390.954C400.921 70 409 78.0793 409 88.0457V174.954C409 184.921 400.921 193 390.954 193H251.046C241.079 193 233 184.921 233 174.954V88.0457Z"
        fill="#040B2B"
      />
      <path
        d="M239 89.6055C239 82.3985 244.863 76.567 252.07 76.6057L389.395 77.3417C396.503 77.3799 402.263 83.1213 402.324 90.23L403 169H239L239 89.6055Z"
        fill="#E6E8E9"
      />
      <path
        d="M409 176V186.788C409 188.436 408.348 190.016 407.188 191.181C406.027 192.346 404.453 193 402.812 193H239.188C237.547 193 235.973 192.346 234.812 191.181C233.652 190.016 233 188.436 233 186.788V176H409Z"
        fill="#040B2B"
      />
      <path
        d="M367 225.826V228H255V226.261L255.154 225.826L257.915 218H364.71L367 225.826Z"
        fill="#040B2B"
      />
      <path
        d="M409.942 224.148C409.741 225.018 408.983 225.935 407.271 226.803C401.125 229.917 388.628 225.972 388.628 225.972C388.628 225.972 379 224.312 379 219.952C379.27 219.765 379.552 219.595 379.844 219.444C382.428 218.059 390.995 214.641 406.186 219.589C407.305 219.945 408.304 220.608 409.073 221.506C409.689 222.236 410.171 223.162 409.942 224.148Z"
        fill="#2969F2"
      />
      <path
        d="M409.94 223.967C402.207 226.813 395.315 227.026 388.241 222.306C384.673 219.926 381.432 219.337 379 219.382C381.656 218.032 390.463 214.7 406.079 219.523C407.229 219.87 408.257 220.517 409.047 221.392C409.68 222.104 410.176 223.006 409.94 223.967Z"
        fill="#2256C6"
      />
      <ellipse cx="400.5" cy="222" rx="2.5" ry="1" fill="#E6E8E9" />
      <circle cx="321" cy="184" r="4" fill="#2969F2" />
      <path
        d="M144.181 83.9167C150.781 82.81 157.692 82.5903 164.183 83.8207C178.511 86.5364 187.644 95.7383 188.858 113.099C189.767 126.093 186.533 136.58 179.84 147.662C179.337 148.495 178.441 149.903 177.501 151.36L177.187 151.847C175.666 154.202 174.136 156.533 174.066 156.644C172.239 159.54 171.315 161.442 171.046 163.028C170.464 166.452 173.359 168.8 182.209 171.03L181.72 172.97C171.98 170.515 168.258 167.497 169.074 162.693C169.4 160.771 170.414 158.685 172.374 155.577C172.454 155.451 173.941 153.185 175.433 150.877L175.752 150.382C176.707 148.901 177.624 147.464 178.128 146.628C184.625 135.87 187.739 125.77 186.863 113.239C185.716 96.8325 177.287 88.3399 163.811 85.7857C157.585 84.6057 150.898 84.8182 144.511 85.8891C143.352 86.0835 142.303 86.2915 141.383 86.4992C141.063 86.5715 140.782 86.6385 140.543 86.6983C140.403 86.7336 140.308 86.7583 140.263 86.7706L139.737 84.8412C139.795 84.8253 139.903 84.7971 140.057 84.7583C140.311 84.6947 140.607 84.6241 140.943 84.5483C141.898 84.3326 142.984 84.1174 144.181 83.9167Z"
        fill="#040B2B"
      />
      <path
        d="M177.094 178.292C179.1 177.938 181.201 177.868 183.195 178.266C187.679 179.16 190.582 182.237 190.957 187.883C191.232 192.019 190.252 195.364 188.238 198.872C188.096 199.119 187.852 199.523 187.592 199.947L187.396 200.267C186.971 200.958 186.563 201.612 186.547 201.639C186.056 202.457 185.815 202.979 185.755 203.355C185.658 203.951 186.22 204.43 188.496 205.033L187.983 206.967C184.837 206.132 183.469 204.965 183.78 203.037C183.893 202.337 184.217 201.635 184.832 200.611C184.877 200.534 186.118 198.547 186.503 197.876C188.336 194.683 189.207 191.712 188.962 188.016C188.648 183.302 186.429 180.95 182.804 180.227C181.088 179.885 179.223 179.948 177.441 180.262C177.118 180.319 176.825 180.38 176.57 180.44C176.422 180.476 176.322 180.502 176.276 180.515L175.724 178.593C175.997 178.515 176.468 178.403 177.094 178.292Z"
        fill="#040B2B"
      />
      <rect x="71" y="52" width="71" height="83" fill="#040B2B" />
      <rect x="64" y="43" width="86" height="30" fill="#E6E8E9" />
      <rect x="64" y="78" width="86" height="30" fill="#E6E8E9" />
      <rect x="64" y="113" width="86" height="30" fill="#E6E8E9" />
      <rect x="128" y="49" width="5" height="5" fill="#FAA692" />
      <rect x="135" y="49" width="5" height="5" fill="#F77A5C" />
      <rect x="143" y="49" width="5" height="5" fill="#F55C38" />
      <rect x="128" y="83" width="5" height="5" fill="#FAA692" />
      <rect x="135" y="83" width="5" height="5" fill="#F77A5C" />
      <rect x="143" y="83" width="5" height="5" fill="#F55C38" />
      <rect x="128" y="118" width="5" height="5" fill="#FAA692" />
      <rect x="135" y="118" width="5" height="5" fill="#F77A5C" />
      <rect x="143" y="118" width="5" height="5" fill="#F55C38" />
    </svg>
  );
});

InternalServerErrorIllustration.displayName = 'InternalServerErrorIllustration';

export { InternalServerErrorIllustration };
